export const BACKEND_BASE_URL = 'https://app.ai.itsdcloud.com/service/api/v1';


export const environment = {
    production: false,
    endpoints: {
        files: `${BACKEND_BASE_URL}/files`,
        upload: `${BACKEND_BASE_URL}/upload`,
        users: `${BACKEND_BASE_URL}/users`,
        chat: `${BACKEND_BASE_URL}/chat`,
        login: `${BACKEND_BASE_URL}/login`,
        models: `${BACKEND_BASE_URL}/models`,
        modelsDefault: `${BACKEND_BASE_URL}/models/default`,
        systemPrompt: `${BACKEND_BASE_URL}/system-prompt`,
        importPostgres: `${BACKEND_BASE_URL}/import/postgres`,
        adminClear: `${BACKEND_BASE_URL}/admin/clear`,
    }
}
